module.exports = __webpack_public_path__ + "images/rovo_collection_1.106c110714842ada9f76ed06e98ea2d8.png";